<template>
  <div id="content" class="myAccount">
    <AddAccount :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="createTheAccount($event)" formName="Add an account" ></AddAccount>
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="confirmDelete($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <TransfertAccount :dialogVisible='dialogTransfert' :userManaged="userInfo.account_managed" @close="closeTransfert()" @newValueIsProposed="transfertOwnerShip($event)" formName="Transfer an account" ></TransfertAccount>
    <ConfirmModal :dialogVisible='showConfirmDialogGrantt' @close="closeConfirmDialogGrantt()" @confirmed="granttAccess($event)" message="After upgrading the user’s access, you won’t be able to restrict it.
<br/><br/>Looking to invite a user to your project?<br/> Send an invitation to collaborate from your project’s dashboard." ></ConfirmModal>

<ConfirmModal :dialogVisible='show_support_request_confirm' @close="show_support_request_confirm=false" @confirmed="realRequestSupport($event)" title="Innopearl experts will access your workspace." message="Not included in your plan?<br/> You’ll get a quote" ></ConfirmModal>

<ConfirmModal :dialogVisible='show_remove_support_dialog' @close="cancelDeleteAccompagnant" @confirmed="deleteAccompagnantReal($event)"  message="Are you sure you want to confirm the removal of this expert from your support team?" ></ConfirmModal>


    <div class="container">
      <div class="myAccountContent" v-if="userInfo">
                      <router-link to="/login" type="button" class="disconnect dinline" name="button">
                        LOGOUT</router-link>
          <div class="myaccountlogo">

            <img  v-if="userInfo.logo"  :src="this.apiUrl+'/get_image/'+userInfo.logo.$oid+'?token='+$store.state.innotoken"   alt="" class="myaccountlogoImage">
            <div class="fallBackLogoProfile" v-else style="">
    YOUR LOGO
            </div>
            <div class="changeImageLogo" v-if=" userInfo._id && userInfo.role == 'Responsable'">
               <button type="button" name="button" @click='$refs.logoUp.focus();$refs.logoUp.click();'>
                   <v-icon icon="mdi:mdi-pencil-outline" style="font-size: 20px;"/>
               </button>
               <input type="file" ref="logoUp" name="logoUp" id="logoUp" @change="selectLogo" accept="image/*"/>
              </div>
              <div class="row uploadProceedBanner" v-if="uploadProceedLogo">
                <div class="col-12 text-center uploadProcess">
                    <span class="progressText">Upload in progress. Please wait a moment.</span>
                  <v-progress-linear
                    v-model="progress"
                    color="blue-grey"
                    height="25"
                  >
                </v-progress-linear>

                </div>

              </div>
          </div>


        <span class="title" v-if="loginFrom">Welcome, {{fullname}}, to the {{userInfo.entreprise}} Workspace</span>

        <span class="title" v-else>Welcome {{userInfo.firstname}} {{userInfo.lastname}}</span>


          <div class="row mt20">
            <v-tabs class="mt20 stickit" v-model="maintab" bg-color="primary" align-tabs="center"   show-arrows center-active>
              <v-tab value="account_detail">Account details</v-tab>
              <v-tab value="company" v-if="userInfo.role == 'Responsable'">Company details</v-tab>
              <v-tab value="user" v-if="userInfo.role == 'Responsable'" >Manage users</v-tab>
              <v-tab value="project" >Project list</v-tab>
            </v-tabs>
            <v-window v-model="maintab">
              <v-window-item value="account_detail" class="maintabitem">
                <div class="row mt20">

                    <div class="row" style="padding:10px;">
                      <div class="col-12 col-lg-6">
                        <StartupInfoLine v-if="userInfo.username" name="Username" :value="userInfo.username"/>
                        <StartupInfoLine v-if="userInfo.email" name="Email" :value="userInfo.email"/>
                        <StartupInfoLine v-if="userInfo.role" name="Platform rights" :value="this.formatedRole(userInfo.role)"/>
                        <StartupInfoLine v-if="userInfo.rights" name="Access" :value="this.formatedRights(userInfo.rights)"/>


                      </div>
                    <div class="col-12 col-lg-6">
                      <StartupInfoLine v-if="userInfo.entreprise" name="Entreprise" :value="userInfo.entreprise"/>
                      <StartupInfoLine v-if="userInfo.industry" name="Industry" :value="userInfo.industry" :isArray='Array.isArray(userInfo.industry)'/>
                      <StartupInfoLine v-if="userInfo.ufunction" name="Function" :value="userInfo.ufunction" :isArray='Array.isArray(userInfo.ufunction)'/>
                      <!-- <StartupInfoLine v-if="userInfo.licence_end" name="Licence expiration" :value="userInfo.licence_end" :isDate='true'/> -->
                    </div>



                      <button @click="resetPwd" href="#" class="prev_step_btn mt20 mb20">Change your password</button>

                  </div>

                </div>
              </v-window-item>
              <v-window-item value="company" class="maintabitem">
                <div class="row mt20" v-if="userInfo.role == 'Responsable'">
                  <!-- only if role is Responsable then display subaccount -->
                  <div class="">
                        <span class="title">About company </span>
                        <div class="text-center"><small class="text-center">Add a brief overview of your company and team to your Scouting landing page.</small></div>

                    <textarea name="name" class="customTextArea" v-model="userInfo.about_company" rows="4" cols="80" placeholder="A short description of your company and team."></textarea>
                    <div class="text-center">
                      <button @click="updateCompanyDesc" href="#" class="btn text-center prev_step_btn mt20 mb20">Update the company description</button>

                    </div>

                  </div>

                  <div class="mt20">
                        <span class="title">Terms and conditions </span>
                        <div class="text-center"><small class="text-center">Show the Terms and Conditions that apply to applicant participation on your landing page.</small></div>
                    <textarea name="name" class="customTextArea" v-model="userInfo.terms_and_conditions" rows="4" cols="80" placeholder="Your terms and conditions that will be used for your Link+ campaign."></textarea>
                    <div class="text-center">
                      <button @click="updateTerms" href="#" class="btn text-center prev_step_btn mt20 mb20">Update the terms and conditions</button>

                    </div>

                  </div>
                  <!-- only if role is Responsable then display subaccount -->
                  <div class="mt50">
                        <span class="title">My banner </span>
                        <div class="text-center"><small class="text-center">Personalize your banner to reflect your company’s visual identity.</small></div>

                        <div class="mylink_banner" >
                           <img :src="this.apiUrl+'/get_image/'+smyLinkPlus_image+'?token='+$store.state.innotoken" alt="" class="forceSize" >
                           <div class="changeImage">
                              <button type="button" name="button" @click='dialogImage = true'>+ CHANGE IMAGE</button>
                              <ImageChange :dialogVisible='dialogImage' @close="dialogImage=false" @newValueIsProposed="imageChangeVal($event)" ></ImageChange>
                          </div>
                        </div>
                            <small class="text-center" style="text-align:center;">Recommended size: 1600x500px</small>

                  </div>
                </div>
              </v-window-item>
              <v-window-item value="user" class="maintabitem"  v-if="userInfo.role == 'Responsable'">
                <div class="row mt20">
                  <span class="title">Configure users and access rights </span>
                  <div class="text-center"><small class="text-center">Manage team access and permissions.</small></div>

                  <div class="mt20">
                    <span><strong>Licenses available:</strong> {{userInfo.licence}} </span><br/>
                    <span><strong>Licenses allocated:</strong> {{userInfo.account_managed.length + 1}} </span><br/>
                    <span v-if="userInfo.licence_end"><strong>Licenses expiration:</strong> {{formatedDate(userInfo.licence_end)}} </span>
                  </div>

                  <table class="table mt20" v-if="userInfo.account_managed.length > 0">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Username</th>
                        <th>Active</th>
                        <th>Rights</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, u) in userInfo.account_managed" :key="u">
                      <td>{{user.firstname}} {{user.lastname}}</td>
                        <td>{{user.email}}</td>

                            <td>{{user.username}}</td>
                        <td>
                          <v-badge v-if="user.isValid" color="info" content="Yes" inline></v-badge>
                          <v-badge v-else color="warning" content="No" inline></v-badge>
                        </td>
                        <td>
                          {{formatedRights(user.rights)}}
                        </td>
                        <td>
                          <div style="display:flex;flex-wrap:wrap;gap:10px;justify-content:center;flex-direction:column;">
                            <button class="btn remove" type="button" @click="deleteAccount(user._id.$oid)" name="button">Remove</button>
                            <button v-if="user.rights == 'OwnProjectOnly'" class="btn upgrade" type="button" @click="granttRightsModal(user._id.$oid)" name="button">Upgrade </button>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div class="mt20" style="display:flex;flex-wrap:wrap;gap:20px;justify-content:center;">
                    <button type="button" class="btn  btn-primary" name="button" @click="openModal()" v-if="userInfo.account_managed.length < userInfo.licence">+ New user</button>
                    <a href="mailto:olga.guerous@innopearl.ch" class="btn btn-primary">Request more licenses</a>
                    <button type="button" v-if="userInfo.role == 'Responsable'" class="btn btn-dark" @click="openTransfert()" name="button">Transfer administrator’s rights</button>
                    <!-- <button type="button" v-if="userInfo.role == 'Responsable'" class="btn btn-primary" @click="requestAccompagnement()" name="button">Request support</button> -->

                  </div>


                </div>
                <div class="row mt50" v-if="userInfo.accompagne_me">
                <span class="title">My extended team</span>
                <div class="text-center"><small class="text-center">Receive personalized support on your projects directly within your workspace</small></div>



                <table class="table mt20" >
                  <thead>
                    <tr>
                      <th >Expert Name</th>
                      <th >Email</th>
                      <th> First connection</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, u) in userInfo.accompagne_me" :key="u">
                    <td>{{user.firstname}} {{user.lastname}}</td>
                    <td>{{user.email}}</td>
                    <td> <span v-if="userInfo['support_login_' + user._id.$oid]">{{userInfo['support_login_' + user._id.$oid]}}</span></td>
                    <td class="text-right">

                      <button class="btn remove" type="button" @click="deleteAccompagnant(user._id.$oid,userInfo._id.$oid)" name="button">Revoke access</button>
                    </td>
                    </tr>

                  </tbody>
                </table>
                <div class="mt20" style="display:flex;flex-wrap:wrap;gap:20px;justify-content:center;"  v-if="userInfo.role == 'Responsable'" >
                   <button type="button" v-if="userInfo.role == 'Responsable'" class="btn btn-primary" @click="requestAccompagnement()" name="button">Request support</button>

                </div>
              </div>
              </v-window-item>
              <v-window-item value="project" class="maintabitem">
                <div class="row mt20">

                  <div class="">
                    <span class="title">My projects list</span>
                    <div class="text-center"><small class="text-center">View and track all project statuses in one place.</small></div>

                    <v-tabs class="mt20" v-model="tab" bg-color="primary" align-tabs="center" show-arrows center-active>
                      <v-tab value="open">Current projects</v-tab>
                      <v-tab value="closed" >Closed projects</v-tab>
                    </v-tabs>
                    <v-window v-model="tab">
                      <v-window-item value="open">
                        <table class="table mt20">
                          <thead>
                            <tr>
                              <th>Project name</th>
                              <th>Initiated by </th>
                              <th>Business Challenge</th>
                              <th>Scouting Challenge</th>
                              <th>Assessment Challenge</th>
                              <th>Status</th>

                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(project,p) in myProjects.open" :key="p">
                              <td>
                                <router-link :to="'/admin/project/'+project._id.$oid" class="submenu_link nodeco" v-if="role == 'Admin'">
                                  <span class="small_menu_title">{{project.name}}</span>
                                </router-link>

                                <router-link :to="'/expert/project/'+project._id.$oid" class="submenu_link nodeco" v-else-if="role == 'Expert'">
                                  <span class="small_menu_title">{{project.name}}</span>
                                </router-link>

                                <router-link :to="'/projet/'+project._id.$oid" class="submenu_link nodeco" v-else>
                                  <span class="small_menu_title">{{project.name}}</span>
                                </router-link>
                              </td>
                              <td>
                                <span v-if="project.user.firstname">{{project.user.firstname }} {{project.user.lastname}}</span>
                                <span v-else>Not set</span>
                              </td>
                              <td>
                                <v-badge v-if="project.challenges.business_challenge == true" color="info" content="Yes" inline></v-badge>
                                <v-badge v-else color="warning" content="No" inline></v-badge>
                              </td>
                              <td>
                                <v-badge v-if="project.challenges.scouting_challenge == true" color="info" content="Yes" inline></v-badge>
                                <v-badge v-else color="warning" content="No" inline></v-badge>
                              </td>
                              <td>
                                <v-badge v-if="project.challenges.assessment_challenge == true" color="info" content="Yes" inline></v-badge>
                                <v-badge v-else color="warning" content="No" inline></v-badge>
                              </td>
                              <td>
                                <v-badge v-if="project.isSubmit == true" color="danger" content="Closed" inline></v-badge>
                                <v-badge v-else color="green" content="Open" inline></v-badge>
                              </td>

                            </tr>
                          </tbody>
                        </table>
                      </v-window-item>
                        <v-window-item value="closed">
                          <table class="table mt20">
                            <thead>
                              <tr>
                                <th>Project name</th>
                                <th>Initiated by </th>
                                <th>Business Challenge</th>
                                <th>Scouting Challenge</th>
                                <th>Assessment Challenge</th>
                                <th>Status</th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(project,p) in myProjects.closed" :key="p">
                                <td>
                                  <router-link :to="'/admin/project/'+project._id.$oid" class="submenu_link nodeco" v-if="role == 'Admin'">
                                    <span class="small_menu_title">{{project.name}}</span>
                                  </router-link>

                                  <router-link :to="'/expert/project/'+project._id.$oid" class="submenu_link nodeco" v-else-if="role == 'Expert'">
                                    <span class="small_menu_title">{{project.name}}</span>
                                  </router-link>

                                  <router-link :to="'/projet/'+project._id.$oid" class="submenu_link nodeco" v-else>
                                    <span class="small_menu_title">{{project.name}}</span>
                                  </router-link>
                                </td>
                                <td>
                                  <span v-if="project.user.firstname">{{project.user.firstname }} {{project.user.lastname}}</span>
                                  <span v-else>Not set</span>
                                </td>
                                <td>
                                  <v-badge v-if="project.challenges.business_challenge == true" color="info" content="Yes" inline></v-badge>
                                  <v-badge v-else color="warning" content="No" inline></v-badge>
                                </td>
                                <td>
                                  <v-badge v-if="project.challenges.scouting_challenge == true" color="info" content="Yes" inline></v-badge>
                                  <v-badge v-else color="warning" content="No" inline></v-badge>
                                </td>
                                <td>
                                  <v-badge v-if="project.challenges.assessment_challenge == true" color="info" content="Yes" inline></v-badge>
                                  <v-badge v-else color="warning" content="No" inline></v-badge>
                                </td>
                                <td>
                                  <v-badge v-if="project.isSubmit == true" color="danger" content="Closed" inline></v-badge>
                                  <v-badge v-else color="green" content="Open" inline></v-badge>
                                </td>

                              </tr>
                            </tbody>
                          </table>
                        </v-window-item>
                      </v-window>

                  </div>

                </div>
              </v-window-item>
            </v-window>
          </div>






      </div>
    </div>
                      <span class="infoVersion">Version 1.2.0</span>
  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
import api from '../tools/api';
import StartupInfoLine from '@/components/InfoStartupLine.vue'
 import AddAccount from '@/components/modals/addAccount.vue'
 import ConfirmModal from '@/components/modals/ConfirmModal.vue'
 import TransfertAccount from '@/components/modals/transfertAccount.vue'
 import ImageChange from '@/components/modals/imageChange.vue'

import { mapState } from 'vuex';
export default {
  components: {
    StartupInfoLine,
    AddAccount,
    TransfertAccount,
    ConfirmModal,
    ImageChange
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "My dashboard space",
        subTitle : "Monitor progress and manage next steps",
      },
      show_support_request_confirm:false,
      apiUrl: process.env.VUE_APP_API_URL,
      chunksLogo: [],
      uploaded: 0,
      uploadProceed: false,
      uploadProceedLogo:false,
      maintab:"account_detail",
      tab: "open",
      dialog:false,
      dialogImage:false,
      granttfor :null,
      show_remove_support_dialog:false,
        showConfirmDialog: false,
        asked_for_delete : null,
      userInfo: {},
      showConfirmDialogGrantt:false,
      dialogTransfert: false,
      transfertManaged: [],
      myProjects: [],
      headers:[
        { text: "Project Name", value: "name", sortable: true  },
        { text: "Business challenge", value: "challenges.business_challenge", sortable: true },
        { text: "Scouting challenge", value: "challenges.scouting_challenge", sortable: true },
        { text: "Assessment challenge", value: "challenges.scouting_challenge", sortable: true }
      ],
    }
  },
  methods:{
    selectLogo(event) {
      this.uploaded = 0;
        this.file = event.target.files.item(0);
        this.createChunksLogo();
        this.uploadProceedLogo = true;
        // console.log(this.chunks);
        // this.upload();
    },
  uploadLogo() {
        this.axios(this.configLogo).then((r) => {
          console.log(r);
          this.chunksLogo.shift();
          if(r.data)if(r.data)this.addedFile = r.data;
        }).catch(error => {console.log(error);this.uploadProceed = false;toast.error("Error during upload");});
    },
  createChunksLogo() {
        let size = 8192, chunks = Math.ceil(this.file.size / size);

        for (let i = 0; i < chunks; i++) {
            this.chunksLogo.push(this.file.slice(
                i * size, Math.min(i * size + size, this.file.size), this.file.type
            ));
        }
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    openModal(){
            this.dialog = true;
    },
    openTransfert(){
      this.dialogTransfert = true;
    },
    closeTransfert(){
      this.dialogTransfert = false;
    },
    closeModal(){
      this.dialog = false;
    },
    logoChange(val){
      if(val){
        this.userInfo.logo = val;
        this.$store.commit('LOGOSET',val);
      }
    },
    granttRightsModal(u){
      this.showConfirmDialogGrantt = true;
      this.granttfor = u;
    },
    closeConfirmDialogGrantt(){
      this.showConfirmDialogGrantt = false;
      this.granttfor = null;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
      this.asked_for_delete = null;
    },
    realRequestSupport(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/request_accompagnement",{},{
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Your support request has been forwarded to Innopearl")
          this.show_support_request_confirm = false;
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
           this.show_support_request_confirm = false;
         });
      }
    },
    cancelDeleteAccompagnant(){
      this.accompagne_r = null;
      this.accompagnant_r = null;
      this.show_remove_support_dialog = false;
    },
    deleteAccompagnant(accompagnant,accompagne){
      this.accompagne_r = accompagne;
      this.accompagnant_r = accompagnant;
      this.show_remove_support_dialog = true;
    },
    deleteAccompagnantReal(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_accompagnant",
        {
          accompagne : this.accompagne_r,
          accompagnant : this.accompagnant_r,
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          this.show_remove_support_dialog = false;
          this.accompagne_r = null;
          this.accompagnant_r = null;
          toast.success("The expert has been successfully removed from your support team.")
            api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
              // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
              // console.log();
              // var temp = _.merge(this.candidatespool, r.data)
              console.log(r.data);
              this.userInfo = r.data;
              this.$store.commit('UPDATE_ROLE',r.data.role);
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });

        });
      }

    },
    requestAccompagnement(){
        this.show_support_request_confirm = true;

    },
    imageChangeVal(val){
      console.log("imageval",val);
      if(val){
        api.post(process.env.VUE_APP_API_URL+"/restrict/udpate_banner",
            {
                banner: val,
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            toast.success("Company description updated")
            api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
              // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
              // console.log();
              // var temp = _.merge(this.candidatespool, r.data)
              console.log(r.data);
              this.userInfo = r.data;
                      this.dialogImage = false;
            }).catch( (e) => {
              console.log(e);
                      this.dialogImage = false;
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
             });
          }).catch( (e) => {
            console.log(e);
                    this.dialogImage = false;
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
           });

      }
      else{
        this.dialogImage = false;
      }

    },
    updateTerms(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/udpate_termsandconditions",
          {
              terms: this.userInfo.terms_and_conditions,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Terms and conditions updated")
          api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.userInfo = r.data;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
           });
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
         });
    },
    updateCompanyDesc(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/udpate_companydesc",
          {
              about_company: this.userInfo.about_company,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Company description updated")
          api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.userInfo = r.data;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
           });
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
         });
    },
    confirmDelete(v){
      console.log(v);
      console.log(this.asked_for_delete);
      this.showConfirmDialog = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/removeaccount",
          {
              toremoved: this.asked_for_delete,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
            toast.success("User successfully delete from your account.")
          api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.userInfo = r.data;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });

        api.get(process.env.VUE_APP_API_URL+"/restrict/all_projects").then( (r) => {
          this.myProjects = r.data;
          console.log(r);
        }).catch( (e) => console.log(e));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.asked_for_delete = null;
    },
    deleteAccount(v){
      this.showConfirmDialog = true;
      this.asked_for_delete = v;
    },
    formatedRole(r){
      if(r == "Responsable"){
        return "Administrator";
      }
      else if(r == "Customer"){
        return 'User';
      }
      else{
        return r;
      }
    },
    formatedDate(r){
      const date = new Date(r.date);
      if (!isNaN(date.getTime())) {
        // Then specify how you want your dates to be formatted
        return new Intl.DateTimeFormat('fr',{
  dateStyle: "short",
}).format(date);
}else{
  return r;
}
    },
    formatedRights(r){
      if(r == "FullProjectAccess"){
        return "All projects";
      }
      else if(r == "OwnProjectOnly"){
        return "My projects";
      }
      else{
        return "N.D.";
      }
    },
    createTheAccount(v){
      console.log(v);
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/register_from_responsable",v,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
           console.log(r);
          api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log("myaccont",r.data);
            this.userInfo = r.data;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
          toast.success("A new user has been  added. An email for a password setup has been sent to their provided address.")
          this.dialog = false;
        }).catch( (e) => {
          console.log(e);
          this.dialog = false;
          if(e.response.data){
            if(e.response.data.message)toast.error(e.response.data.message);
            else toast.error(e.response.data);
          }
          else toast.error("Sorry, an error occurred. Please try again. ");
        })
      }
    },
    removeAccount(a){
      console.log(a);
    },
    resetPwd(){
      var uname = this.userInfo.username;
       if(!uname){
         uname= prompt("Please provide your username to reset your password");
       }
       if(uname){
        this.axios.post(process.env.VUE_APP_API_URL+"/password_reset",{'username':uname},{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("A password reset email has been sent to your inbox. Please check it and follow the instructions.");
        }).catch(() =>{

          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ");
        })
        }
      },
      granttAccess(v){
        if(v){
          api.post(process.env.VUE_APP_API_URL+"/restrict/granttAccess/"+this.granttfor,{},{
            headers: {
                'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
                this.userInfo = r.data;
                this.showConfirmDialogGrantt =false;
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
          toast.success("Account rights successfully grantted to full access !");
          this.showConfirmDialogGrantt = false;
          });
        }
      },
      transfertOwnerShip(v){
        console.log(v);
        if(v){
          api.post(process.env.VUE_APP_API_URL+"/restrict/transfertOwnerShip",v,{
            headers: {
                'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
              // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
              // console.log();
              // var temp = _.merge(this.candidatespool, r.data)
              console.log(r.data);
              this.userInfo = r.data;
              this.$store.commit('UPDATE_ROLE',r.data.role);
            }).catch( (e) => {
              console.log(e);
               toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
          toast.success("Account ownership successfully tranfered !");
          this.dialogTransfert = false;
          });
        }
      }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount_with_accompagnant").then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       this.userInfo = r.data;
       this.$store.commit('UPDATE_ROLE',r.data.role);
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });

   api.get(process.env.VUE_APP_API_URL+"/restrict/all_projects").then( (r) => {
     this.myProjects = r.data;
     console.log(r);
   }).catch( (e) => console.log(e));
 },
 computed:{
    ...mapState(['role','myProjects','customerlogo','loginFrom','fullname']),
   smyLinkPlus_image(){
     if(this.userInfo.banner){
       console.log(this.userInfo.banner);
       return this.userInfo.banner.$oid;
     }
     else{
       return null;
     }
   },
   formDataLogo() {
       let formData = new FormData;

       formData.set('imageTargetDBField', "logo");
       formData.set('is_last', this.chunksLogo.length === 1);
       formData.set('file', this.chunksLogo[0], `${this.file.name}.part`);
       formData.set('file_extension_original', this.file.name.split('.').pop());
       formData.set('account', this.userInfo._id.$oid);
       formData.set('fileType', "logo");
       return formData;
   },
   configLogo() {
       return {
           method: 'POST',
           data: this.formDataLogo,
           url: this.apiUrl+'/upload_logo_account',
         //  url: this.apiUrl+'/restrict/test_upload_startup/649c14ec4df341c71a0a5d03',

           headers: {
               'Content-Type': 'application/octet-stream'
           },
           onUploadProgress: event => {
               this.uploaded += event.loaded;
           }
       };
   }
 },
 watch: {


   chunksLogo: {
     handler(val) {
       if (val.length > 0) {
              this.uploadLogo();
       }
       else{
         this.uploadProceedLogo = false;
         this.logoChange(this.addedFile);

       }
     },
     deep: true
   },

 }
}
</script>
<style scoped >
.myAccount{
  padding-top:50px;
  padding-bottom: 50px;
}
.myAccountContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-top:50px;
margin-bottom: 50px;

}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
text-align:center;
}
.mt50{
  margin-top:50px;
}


.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}

.myAccountContent{
  position:relative;
  padding-top:80px;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}

.disconnect{
  position: absolute;
top: 10px;
right: 10px;
padding: 5px 20px;
color: #3783C5;
border: none;
border-bottom: 1px solid #3783C5;
border-radius: 0;
font-size: 16px;
font-weight: bold;
text-decoration: none;
}

.infoVersion{
  position: absolute;
  bottom: 5px;
  right: 15px;
  font-size: 10px;
}

.v-window{
  border: 1px solid #3783C5;
  margin-bottom:50px;
}
.v-tabs{
      background: #115AA4 !important;

}
.v-tab--selected{
  background: #3783C5 !important;
}
.v-tab__slider{
  display:none;
}


.btn-primary{
    background: #3783C5 !important;
    border: 1px solid #3783C5 !important;
  border-radius: 50px;
}
.btn-dark{
    background: #fff !important;
    border: 1px solid #000 !important;
  border-radius: 50px;
  color:#000;
}

.nodeco, .nodeco:hover{
  color:inherit !important;
  text-decoration:none !important;
}
.myaccountlogo{
  width:250px;
  height:100px;
  display:flex;
  justify-content: center;
  align-items: center;
  margin-bottom:20px;
  position:relative;
  margin: auto;
    margin-bottom: auto;
  margin-bottom: 20px;
}
.myaccountlogoImage{
  width:250px;
  height:100px;
  object-fit: contain;
  margin: auto;
}

.customTextArea{
  width:100% !important;
  border:1px solid #CCC;
  margin-top:20px;
  padding:10px;
}


.changeImage{
  position:absolute;
  top:15px;
  right:30px;
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;

}
.mylink_banner{
  margin-top: 20px;
  position:relative;
  height:300px;
  background:#EFEFEF;
  padding: 0 !important;
}
.mylink_banner img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.upgrade{
  border:1px solid #3783C5;
  color:#3783C5;
  background:#FFF;
  padding:5px 10px;
  font-size:12px;
  line-height: 15px;
  margin-left:10px;
  align-self: center;
  border-radius: 50px;
}
.remove{
  border:1px solid #C63221;
  color:#C63221;
  background:#FFF;
  padding:5px 10px;
  font-size:12px;
  line-height: 15px;
  margin-left:10px;
  align-self: center;
}

.fallBackLogoProfile{
  width:250px;
  height:100px;
  background:#EFEFEF;text-align:center;text-align: center;
display: flex;
justify-content: center;
align-content: center;
align-items: center;
}


.changeImageLogo{
  position:absolute;
  top:5px;
  right:5px;
  font-size:12px;
  line-height: 12px;
  color:#000;
  background:#FFF;
  border-radius:50%;;
  padding: 5px;

}


.uploadProceedBanner{
  position: absolute;
    top: 0;
    left: 0;
    transform: none;
    background: rgba(255,255,255,0.9);
    padding: 20px;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
}
.uploadProceedBanner .uploadProcess{
  width:80%;
}

#logoUp{
  display: none;
}

.maintabitem{
  padding:25px 50px;
  overflow: scroll;
}

.stickit{
  position:sticky;
  top:0;
  bottom:50px;
  z-index:10;
}
@media screen and (max-width:990px){
  .maintabitem{
    padding:25px 20px;
  }

}
@media screen and (max-width:990px){
  .maintabitem{
    padding:10px 5px;
  }

}

</style>
<style media="screen">
.stickit .v-tab--selected {
  background: #B38D2F !important;
  opacity: 1;
  color: #FFF !important;
  font-weight: bold;
}
</style>
